import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import theme from '../../theme.css';
import { QuestionFontIcon } from '../../components/CustomIcons';
import CustomSection from "../../components/CustomSection";
import { getData } from "../../utils/commons";
import { faq_en} from '../../translations/faq_en';
import { faq_gr} from '../../translations/faq_gr';
import CustomAccordion from "../../components/CustomAccordion";


const useStyles = makeStyles((theme) => ({
    item_detail: {
        border: '1px solid #e7eaec',
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(1),
        background: theme.palette.background.paper,
    },
}));


export default function FAQsView(props){
    const classes = useStyles();
    const {t} = useTranslation();

    const language = getData('LANGUAGE');
    let faqs = [];
    if(language == 'ENG'){
        faqs = faq_en;
    }else{
        faqs = faq_gr;
    }
    
    return (
        <CustomSection notMarginTop={true} 
            title={t('faq')} 
            icon={<QuestionFontIcon style={{
                color: theme.palette.common.white,
            }}/>}
            customClass={classes.customClass}
        >
            <Grid item xs={12} marginTop={1}>
               {faqs && faqs.length > 0 && faqs.map((item, index) => {
                   return (
                       <Grid item key={index}>
                           <CustomAccordion 
                                sumary={index+1 + '. ' + item.name + ' >>'}
                                details={<RenderDetail t={t} classes={classes} details={item.items}/>}
                           />
                       </Grid>
                   );
               })}
            </Grid>
        </CustomSection>
    );
}

function RenderDetail(props){
    const {t, classes, details} = props;
    if(details && details.length > 0){
        return (
            <Grid item xs={12}>
                {
                    details.map((item, index) => {
                        return (
                            <Grid key={index} item xs={12} marginBottom={2} className={classes.item_detail}>
                                <Typography variant="body2">{item.question ? item.question : null}</Typography>
                                <Typography variant="caption">{item.answer ? item.answer : null}</Typography>
                            </Grid>
                        );
                    })
                }
            </Grid>
        );
    }
    else{
        return <Grid item></Grid>;
    }
}